import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'

export default connect(state => ({auth: state.auth}))(({ component: Component, auth, ...rest }) => {
  return <Route {...rest} render={props =>
    auth.loggedIn
      ? <Component {...props} />
      : <Redirect to={{
        pathname: '/login',
        state: {from: props.location}
      }} />
  } />
})



// WEBPACK FOOTER //
// ./app/components/PrivateRoute.js